var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import isPlainObject from 'lodash/isPlainObject';
import React from 'react';
import PropTypes from 'prop-types';
import Element from './Element';

var PLACEHOLDER_VALUE = ''; // null and undefined is uncontrolled value

var Select = function (_Element) {
  _inherits(Select, _Element);

  function Select(props, context) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, _Element.call(this, props, context));

    _this.onChange = function (evn) {
      evn.stopPropagation();

      var nodes = evn.target.options || [];
      var options = _this.state.options;
      var values = [];

      for (var index = 0; index < nodes.length; index++) {
        var node = nodes[index];

        if (!node.selected) {
          continue;
        }

        var optionValue = node.value;
        if (typeof optionValue === 'undefined' || !optionValue.length) {
          continue;
        }

        var optionIndex = Number(optionValue);
        if (!options[optionIndex]) {
          continue;
        }

        values.push(options[optionIndex].value);
      }

      var isMultiple = _this.isMultiple();

      _this.setValue(isMultiple ? values : values[0]);

      var onChange = _this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(evn);
      }
    };

    _this.state = {
      options: _this.prepareOptions(props.options)
    };
    return _this;
  }

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.setState({
      options: this.prepareOptions(props.options)
    });
  };

  Select.prototype.prepareOptions = function prepareOptions(options) {
    var selectOptions = [];

    if (isPlainObject(options)) {
      Object.keys(options).forEach(function (key) {
        selectOptions.push({
          value: key,
          label: options[key]
        });
      });
    } else if (Array.isArray(options)) {
      options.forEach(function (option) {
        var isObject = isPlainObject(option);

        selectOptions.push({
          value: isObject ? option.value : option,
          label: isObject ? option.label : option
        });
      });
    }

    return selectOptions;
  };

  Select.prototype.getValues = function getValues() {
    var options = this.state.options;

    var value = this.getValue();
    var placeholder = this.props.placeholder;


    var isMultiple = this.isMultiple();
    var values = [];

    options.forEach(function (option, pos) {
      if (!isMultiple && option.value === value) {
        values.push(pos);
      } else if (isMultiple && value && value.length && value.indexOf(option.value) !== -1) {
        values.push(pos);
      }
    });

    if (!values.length && placeholder) {
      values.unshift(PLACEHOLDER_VALUE);
    }

    return isMultiple ? values : values[0];
  };

  Select.prototype.renderPlaceholder = function renderPlaceholder() {
    var placeholder = this.props.placeholder;

    if (typeof placeholder === 'undefined') {
      return null;
    }

    return React.createElement(
      'option',
      { value: PLACEHOLDER_VALUE },
      placeholder
    );
  };

  Select.prototype.isMultiple = function isMultiple() {
    return !!this.props.multi || !!this.props.multiple;
  };

  Select.prototype.getClassName = function getClassName() {
    var className = this.props.className;

    return className;
  };

  Select.prototype.render = function render() {
    var options = this.state.options;
    var _props = this.props,
        path = _props.path,
        disabled = _props.disabled,
        required = _props.required;

    var values = this.getValues();

    return React.createElement(
      'select',
      {
        name: path,
        value: values,
        className: this.getClassName(),
        disabled: disabled,
        required: required,
        multiple: this.isMultiple(),
        onChange: this.onChange
      },
      this.renderPlaceholder(),
      options.map(function (option, pos) {
        return React.createElement(
          'option',
          { value: pos, key: pos },
          option.label
        );
      })
    );
  };

  return Select;
}(Element);

Select.propTypes = _extends({}, Element.propTypes, {
  disabled: PropTypes.bool,
  className: PropTypes.string
});
export default Select;
//# sourceMappingURL=Select.js.map